import template from './teamCalendarList.html';
import controller from './teamCalendarList.controller';
import './teamCalendarList.scss';

let teamCalendarListComponent = {
  restrict: 'E',
  bindings: {
    teamCalendarList: '<',
    isDisabled: '<',
    hasDelegated: '<',
    delegation: '<'
  },
  template,
  controller
};

export default teamCalendarListComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarList/teamCalendarList.component.js